import List from "@/components/list";
import router from "@/router";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function () { };

  // function handleView({ row }) {
  //   Bus.$emit("details", row);
  // }

  // 到审核详情
  function goAuditDetail({ row }) {
    router.push({
      path: "leaveAudit/detail",
      query: { id: row.uuid },
    });
  }

  const Deal = ({ props: { vo } }) => {
    let icon = "icon-steps";
    let explain = "查看审核进度";
    const isAuditTypes = [0, 4]
    const { auditStatus, isAudit } = vo.row
    if (isAuditTypes.includes(Number(auditStatus)) && vo.row.isAudit == true) {
      icon = "icon-audit";
      explain = "审核";
    }
    const dealConf = [
      [icon, explain, () => goAuditDetail(vo), "audit:leave:update"]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "userName",
      minWidth: "90",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "所在班级",
      prop: "className",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "开始时间",
      prop: "leaveStartTimeName",
      width: "150"
    },
    {
      label: "结束时间",
      prop: "leaveEndTimeName",
      width: "150"
    },
    {
      label: "时长（天）",
      prop: "duration",
      width: "80"
    },
    {
      label: "请假类型",
      prop: "leaveTypeName",
      width: "80"
    },
    {
      label: "申请事由",
      prop: "auditNotes",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "审核状态",
      prop: "auditStatusName",
      width: "100",
      // render: vo => (
      //   <span>{vo.row.auditStatus == 0 ? "审核中" : (vo.row.auditStatus == 1 ? "审核通过" : "审核不通过")}</span>
      // )
    },
    {
      label: "提交时间",
      prop: "createDate",
      width: "150"
    },
    {
      label: "操作",
      width: "60",
      fixed: "right",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
